// extracted by mini-css-extract-plugin
export default {"wrap":"ParticipantsDocs_wrap__SdXLe","content":"ParticipantsDocs_content__+QqEv","item":"ParticipantsDocs_item__z4328"};